import { render } from "./Pagination.vue?vue&type=template&id=0c9d5a5c"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Common/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c9d5a5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c9d5a5c', __exports__)) {
    api.reload('0c9d5a5c', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=0c9d5a5c", () => {
    api.rerender('0c9d5a5c', render)
  })

}


export default __exports__